import React from 'react';
import classNames from 'classnames/bind';
import { HastHTMLElement } from '../../types/hastElement';
import FootnoteItem from './FootnoteItem';
import styles from './Footnotes.module.scss';

const cx = classNames.bind(styles);

type FootnotesProps = {
  liElements: HastHTMLElement<'li'>[];
};

function Footnotes({ liElements }: FootnotesProps): JSX.Element {
  return (
    <section className={cx('footnotes')} role="doc-endnotes">
      <hr />
      <ol>
        {liElements.map((liElement, index) => {
          // index를 id로 사용하는 것은 예외 처리를 한 것일 뿐, 정상적인 상황에선 footnote는 id 값을 늘 가지고 있습니다.
          const id = liElement.properties.id ?? index.toString();
          return <FootnoteItem key={id} id={id} index={index} liElement={liElement} />;
        })}
      </ol>
    </section>
  );
}

export default Footnotes;
